import script from "./BmsBoardList.vue?vue&type=script&setup=true&lang=ts"
export * from "./BmsBoardList.vue?vue&type=script&setup=true&lang=ts"

import "./BmsBoardList.vue?vue&type=style&index=0&id=28414386&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28414386"]])

export default __exports__